import React, { Component } from "react";
import { connect } from "react-redux";
import intl from "react-intl-universal";

// Assets
import { createContact } from "../../../actions/contact.action";

// Styles
import "../../../styles/components/forms/contact.scss";

// Components
import { ContactForm } from "./contact.form";

class Contact extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submitStatus: null
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(form) {
    this.props
      .createContact(form)
      .then(() => {
        this.setState({ submitStatus: "submitted" });
      })
      .catch(() => {
        this.setState({ submitStatus: "error" });
      });
  }

  render() {
    return (
      <div className="contact-form-container">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css" integrity="sha512-Evv84Mr4kqVGRNSgIGL/F/aIDqQb7xQ2vcrdIwxfjThSH8CSR7PBEakCr51Ck+w+/U6swU2Im1vVX0SVk9ABhg==" crossOrigin="anonymous" referrerPolicy="no-referrer" />

        <div className="outer-wrap">
          <div className="inner-wrap">
            {
              !this.state.submitStatus ? (
                <>
                  <h2>{intl.getHTML("page.Contact.Form.h")}</h2>
                  <p>{intl.getHTML("page.Contact.Form.p")}</p>
                  <ContactForm onSubmit={this.onSubmit} />
                </>
              ) : ""
            }
            {
              this.state.submitStatus === "submitted" ? (
                <>
                  <h2>{intl.getHTML("page.Contact.Form.submitted.h")}</h2>
                  <p>{intl.getHTML("page.Contact.Form.submitted.p")}</p>
                  <i className="fa fa-check-circle status-icon" aria-hidden="true" style={{ color: "#278271" }}></i>
                </>
              ) : ""
            }
            {
              this.state.submitStatus === "error" ? (
                <>
                  <h2>{intl.getHTML("page.Contact.Form.error.h")}</h2>
                  <p>{intl.getHTML("page.Contact.Form.error.p")}</p>
                  <i className="fa fa-times-circle status-icon" aria-hidden="true" style={{ color: "red" }}></i>
                </>
              ) : ""
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { createContact })(Contact);
